/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_CancelInputs */

const en_dispatch_cancel = /** @type {(inputs: Dispatch_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_dispatch_cancel = /** @type {(inputs: Dispatch_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const ms_sg2_dispatch_cancel = /** @type {(inputs: Dispatch_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Dispatch_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_cancel = /** @type {((inputs?: Dispatch_CancelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_CancelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_cancel(inputs)
	if (locale === "fr") return fr_dispatch_cancel(inputs)
	return ms_sg2_dispatch_cancel(inputs)
});